import { GzTextWebComponent } from './component/GzTextWebComponent';
import { WEB_COMPONENT_GZ_TEXT } from '../../webcomponents.constants';

export { GzTextWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_TEXT, GzTextWebComponent);
